// extracted by mini-css-extract-plugin
module.exports = {"power-independence-B":"B_power-independence-B__TP_FA"};